import { render, staticRenderFns } from "./visitLogs.vue?vue&type=template&id=cf367462&scoped=true"
import script from "./visitLogs.vue?vue&type=script&lang=js"
export * from "./visitLogs.vue?vue&type=script&lang=js"
import style0 from "./visitLogs.vue?vue&type=style&index=0&id=cf367462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf367462",
  null
  
)

export default component.exports